export class User {
  displayName!: string;
  email!: string;
  avatar!: string;
  timeZone!: string;
  isAdmin: boolean = false;
  isAuthenticated: boolean = false;
  isSuperAdmin: boolean = false;
}
